import { API_BASE_URL, buildApiUrl } from './config';

export type Sponsor = {
  id: number;
  name: string;
  logo?: string | null;
  url?: string | null;
  order?: number | null;
};

type ApiEnvelope<T> = {
  data: T;
};

async function request<T>(path: string, params?: Record<string, string | number | boolean | undefined>) {
  const url = buildApiUrl(API_BASE_URL, path, params);

  const response = await fetch(url, {
    headers: {
      Accept: 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`API ${response.status}: ${path}`);
  }

  const json = await response.json() as ApiEnvelope<T> | T;
  return 'data' in Object(json) ? (json as ApiEnvelope<T>).data : json as T;
}

function normalizeList<T>(value: T[] | { data?: T[] }) {
  if (Array.isArray(value)) {
    return value;
  }

  return Array.isArray(value.data) ? value.data : [];
}

export function getSponsors(perPage = 20) {
  return request<Sponsor[] | { data?: Sponsor[] }>('/audiobook-sponsors', { per_page: perPage }).then(normalizeList);
}
